import { Routes } from '@angular/router';
import { MsalGuard } from '@groundworks/ngx-groundworks-auth';
import { PendingSaleComponent } from './components/pending-sale/pending-sale.component';
import { PendingSalesListboxComponent } from './components/pending-sales-listbox/pending-sales-listbox.component';
import { QuotesListboxComponent } from './components/quotes-listbox/quotes-listbox.component';
import { SaleApprovalListboxComponent } from './components/sale-approval-listbox/sale-approval-listbox.component';
import { ShellComponent } from './components/shell/shell';

export const routes: Routes = [
  {
    path: '',
    canActivate: [MsalGuard],
    component: ShellComponent,
    children: [
      {
        path: '',
        component: PendingSalesListboxComponent,
      },
      {
        path: 'quotes-listbox',
        component: QuotesListboxComponent,
      },
      {
        path: 'sale-approval-listbox',
        component: SaleApprovalListboxComponent,
      },
      {
        path: 'pending-sale',
        component: PendingSaleComponent,
      },
      {
        path: 'quote-review',
        component: PendingSaleComponent,
      },
    ],
  },
];
